(() => {
  'use strict';
  const cfg = window.Alcove || {};
  const money = cents => {
    const val = Number(cents);
    if (!Number.isFinite(val)) return '';
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(val / 100);
  };
  const safe = value => String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const drawer = document.querySelector('[data-cart-drawer]');
  let previouslyFocused;
  const setDrawerOpen = open => {
    if (!drawer) return;
    if (open) {
      previouslyFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('.cart-drawer__panel')?.focus();
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      previouslyFocused?.focus?.();
    }
  };
  function errorMessage(error) { return typeof error === 'string' ? error : (error && (error.description || error.message)) || 'Si è verificato un errore. Riprova.'; }
  async function getJSON(url, options) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    let data = null;
    try { data = await response.json(); } catch (_) { /* response may not be JSON */ }
    if (!response.ok) throw new Error(errorMessage(data));
    return data;
  }
  function updateCartBadge(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
  }
  function cartLine(item) {
    const photo = item.image ? `<img src="${safe(item.image)}" alt="${safe(item.product_title)}" loading="lazy">` : '';
    const option = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${safe(item.variant_title)}</small>` : '';
    return `<div class="drawer-item"><a class="drawer-item__image" href="${safe(item.url)}">${photo}</a><div class="drawer-item__info"><a href="${safe(item.url)}">${safe(item.product_title)}</a>${option}<strong>${money(item.final_price)}</strong><div class="drawer-item__qty"><button type="button" aria-label="Riduci quantità" data-cart-change="${safe(item.key)}" data-quantity="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" aria-label="Aumenta quantità" data-cart-change="${safe(item.key)}" data-quantity="${item.quantity + 1}">+</button></div></div><button class="drawer-item__remove" type="button" data-cart-change="${safe(item.key)}" data-quantity="0" aria-label="Rimuovi ${safe(item.product_title)}">Rimuovi</button></div>`;
  }
  const showDrawerError = message => {
    if (!drawer) return;
    const el = drawer.querySelector('[data-cart-error]');
    if (el) { el.textContent = message; el.hidden = !message; }
  };
  async function loadCart() {
    const cart = await getJSON((cfg.cartUrl || '/cart') + '.js');
    updateCartBadge(cart);
    if (!drawer) return cart;
    const items = drawer.querySelector('[data-cart-items]');
    const bottom = drawer.querySelector('[data-cart-bottom]');
    const total = drawer.querySelector('[data-cart-total]');
    if (items) items.innerHTML = cart.items.length ? cart.items.map(cartLine).join('') : '<p>Il carrello è vuoto.</p><p><a href="' + safe(cfg.allProductsUrl || '/collections/all') + '" class="text-link">Esplora i mobili ↗</a></p>';
    if (total) total.textContent = money(cart.total_price);
    if (bottom) bottom.hidden = !cart.items.length;
    showDrawerError('');
    return cart;
  }
  async function changeCartLine(key, quantity) {
    try {
      await getJSON((cfg.changeUrl || '/cart/change') + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity})});
      await loadCart();
    } catch(error) { showDrawerError(errorMessage(error)); }
  }
  if (drawer) {
    drawer.addEventListener('click', e => {
      const close = e.target.closest('[data-cart-close]');
      if (close) { e.preventDefault(); setDrawerOpen(false); return; }
      const change = e.target.closest('[data-cart-change]');
      if (change) { e.preventDefault(); change.disabled = true; changeCartLine(change.dataset.cartChange, Number(change.dataset.quantity)); }
    });
    document.addEventListener('keydown', e => {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); setDrawerOpen(false); }
      if (e.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea')].filter(el => el.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  document.querySelectorAll('[data-cart-trigger]').forEach(el => el.addEventListener('click', e => {
    if (!cfg.enableDrawer || !drawer) return;
    e.preventDefault(); setDrawerOpen(true);
    loadCart().catch(error => showDrawerError(errorMessage(error)));
  }));
  document.querySelectorAll('form.quick-add,form.product-form').forEach(form => form.addEventListener('submit', async event => {
    if (!cfg.enableDrawer || (event.submitter && !event.submitter.matches('[data-add-to-cart]'))) return; // preserve native accelerated checkout
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const failure = form.querySelector('[data-product-error]');
    if (failure) { failure.textContent = ''; failure.hidden = true; }
    if (submit) submit.disabled = true;
    try {
      await getJSON((cfg.addUrl || '/cart/add') + '.js', {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if (drawer) {setDrawerOpen(true);await loadCart();} else {window.location.assign(cfg.cartUrl || '/cart');}
    } catch(error) {
      const msg = errorMessage(error);
      if (failure) {failure.textContent = msg;failure.hidden = false;} else {window.alert(msg);}
    } finally { if (submit) submit.disabled = false; }
  }));
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const dataEl = section.querySelector('[data-product-variants]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch(_) { return; }
    const form = section.querySelector('form.product-form');
    if (!form || !variants.length) return;
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[data-variant-id]');
    const quantity = form.querySelector('[data-quantity]');
    const stockEl = section.querySelector('[data-variant-stock]');
    const priceEl = section.querySelector('[data-variant-price]');
    const compareEl = section.querySelector('[data-variant-compare]');
    const skuLine = section.querySelector('.sku-line');
    const skuEl = section.querySelector('[data-variant-sku]');
    const submit = form.querySelector('[data-product-submit]');
    const mainImage = section.querySelector('#AlcoveMainImage');
    function stockLabel(v) {
      if (!v.available) return 'Esaurito';
      const hasKnownQuantity = Boolean(v.management) && typeof v.quantity === 'number' && Number.isFinite(v.quantity);
      if (hasKnownQuantity && v.quantity <= 0 && v.policy === 'continue') return 'Disponibile su ordinazione';
      if (hasKnownQuantity && v.quantity > 0) return v.quantity <= 5 ? `Solo ${v.quantity} unità disponibili` : `Unità disponibili: ${v.quantity}`;
      return 'Disponibile';
    }
    function renderVariant(v, changeURL = true) {
      if (!v) {
        if (idInput) idInput.value = '';
        if (stockEl) stockEl.textContent = 'Combinazione non disponibile';
        if (submit) { submit.disabled = true;submit.textContent = 'Variante non disponibile'; }
        const checkout = form.querySelector('.shopify-payment-button');
        if (checkout) checkout.hidden = true;
        return;
      }
      if (idInput) {idInput.value = v.id;idInput.dispatchEvent(new Event('change',{bubbles:true}));}
      if (stockEl) stockEl.textContent = stockLabel(v);
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        const show = Number(v.compareAt) > Number(v.price);
        compareEl.hidden = !show;
        compareEl.textContent = show ? money(v.compareAt) : '';
      }
      if (skuLine && skuEl) {skuEl.textContent = v.sku || '';skuLine.hidden = !v.sku;}
      if (submit) {submit.disabled = !v.available;submit.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';}
      const checkout = form.querySelector('.shopify-payment-button');
      if (checkout) checkout.hidden = !v.available;
      if (quantity) {
        const tracked = Boolean(v.management) && typeof v.quantity === 'number' && Number.isFinite(v.quantity);
        if (tracked && v.policy !== 'continue' && v.quantity > 0) quantity.max = String(v.quantity);
        else quantity.removeAttribute('max');
        if (Number(quantity.value) < 1) quantity.value = '1';
        if (quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
      }
      if (v.image && mainImage) {
        mainImage.src = v.image;
        mainImage.removeAttribute('srcset');
        section.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.toggle('is-active', b.dataset.imageSrc === v.image));
      }
      if (changeURL && window.history?.replaceState) {
        const currentURL = new URL(window.location.href);
        currentURL.searchParams.set('variant', String(v.id));
        window.history.replaceState({},'',currentURL.toString());
      }
    }
    function selectedVariant() {
      const opts = optionSelects.map(sel => sel.value);
      return variants.find(v => opts.length === v.options.length && opts.every((val,index) => val === v.options[index]));
    }
    optionSelects.forEach(el => el.addEventListener('change',() => renderVariant(selectedVariant())));
    const urlID = new URL(window.location.href).searchParams.get('variant');
    const initial = variants.find(v => String(v.id) === urlID) || variants.find(v => String(v.id) === idInput.value) || variants[0];
    if (urlID && initial && optionSelects.length) initial.options.forEach((option, index) => {if (optionSelects[index]) optionSelects[index].value = option;});
    renderVariant(initial, false);
    form.querySelectorAll('[data-quantity-change]').forEach(btn => btn.addEventListener('click', () => {
      if (!quantity) return;
      const next = Math.max(1, Number(quantity.value || 1) + Number(btn.dataset.quantityChange));
      quantity.value = quantity.max ? Math.min(Number(quantity.max),next) : next;
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const zoomButton = section.querySelector('[data-gallery-zoom]');
    const zoomDialog = section.querySelector('[data-zoom-dialog]');
    zoomButton?.addEventListener('click', () => {
      if (!zoomDialog || !mainImage) return;
      const zoomImage = zoomDialog.querySelector('[data-zoom-image]');
      if (zoomImage) {zoomImage.src = mainImage.currentSrc || mainImage.src;zoomImage.alt = mainImage.alt;}
      zoomDialog.showModal?.();
    });
    section.querySelectorAll('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = btn.dataset.imageSrc;
      mainImage.alt = btn.dataset.imageAlt || '';
      mainImage.removeAttribute('srcset');
      section.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));
  });
  document.querySelectorAll('[data-filter]').forEach(input => input.addEventListener('change', () => {
    if (input.dataset.filterUrl) window.location.assign(input.dataset.filterUrl);
  }));
  document.querySelectorAll('[data-sort]').forEach(input => input.addEventListener('change', () => input.form?.submit()));
})();
